"use strict";

function freeUpdate() {
  $.getJSON('/cart.js', function (cart) {
    $('.pdp_free_shipping_text').attr('data-cart-total', cart.total_price);
    if (cart.total_price > 8000) {
      $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
      $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
      $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
    } else {
      $('.pdp_free_shipping_text').removeClass('active').addClass('lock_shipping_bar');
      $('.pdp_free_shipping_text .false_free_shipping').removeClass('hidden');
      $('.pdp_free_shipping_text .true_free_shipping').addClass('hidden');
    }
  });
}
function changePrice(variant, image) {
  var activeProduct = $('.pmvt_content .pmvt_content-variants_item.active').length ? $('.pmvt_content .pmvt_content-variants_item.active') : $('.pmvt_content .pmvt_content-variants_item.current');
  var variant = JSON.parse(activeProduct.find('[data-selected-variant]').text());
  var sellingPlan = JSON.parse(activeProduct.find('[data-selected-selling]').text())[0];
  var current = $('.payment-method_item [name="selling_plan"] option:selected').attr('data-name');
  var currentPlan = sellingPlan.selling_plans.find(plan => plan.name === current);
  if (activeProduct.find('.serving_text').length > 0) {
    var serving = JSON.parse(activeProduct.find('[data-selected-serving]').text());
    $('#onetime_serving, #subscribe_serving').removeClass('hidden');
    $('.payment-methods_wrapper').addClass('active_snack_bars');
  } else {
    var serving = JSON.parse(activeProduct.find('[data-selected-serving]').text());
    $('#onetime_serving, #subscribe_serving').addClass('hidden');
    $('.payment-methods_wrapper').removeClass('active_snack_bars');
  }
  var oneTimeServingElement = $('#onetime_serving');
  var subscribeServingElement = $('#subscribe_serving');
  var oneTimePriceElement = $('#onetime-price');
  var subscribePriceElement = $('#subscribe-price');
  var totalPriceElement = $('.total-price');
  var totalComparePriceElement = $('.total-compare-price');
  var saveElement = $('#total-discount');
  var discount = parseInt(currentPlan.price_adjustments[0].value);
  var discount_number = $('.subscribe-label').attr('data-discount-number');
  var free = $('.pdp_free_shipping_text').attr('data-cart-total');
  var totalPriceMain = $('.product-subtotal');
  var subDif = $('.total_sub_label');
  var form = $('.product-form form');
  var selectQty = $('.flavors_number');
  var flavorsText = $('.flavors_text');
  var freeShippingPrice = 8000;
  // var qty = $('.product-qty [name="quantity"]').val();
  if (image) {
    var handle = activeProduct.attr('data-handle');
    if (handle != $('.product-media_main').attr('data-handle')) {
      $.get('/products/' + handle + '?section_id=product-media', function (data) {
        var mediaHTML = $(data).find('.product-media').html();
        $('.product-media').html(mediaHTML);
        theme.sections.register('product', theme.Product);
        MagicZoom.refresh();
      });
    }
  }
  if (oneTimePriceElement) {
    if (activeProduct.find('.serving_text').length > 0) {
      if (variant.price < variant.compare_at_price) {
        oneTimePriceElement.html(`
          <span class="compare-price hidden">${Shopify.formatMoney(variant.compare_at_price)}</span>
          ${Shopify.formatMoney(variant.price)}
          <span class="box_text"> / BOX</span>
        `);
      } else {
        oneTimePriceElement.html(Shopify.formatMoney(variant.price) + '<span class="box_text"> / BOX</span>');
      }
    } else {
      if (variant.price < variant.compare_at_price) {
        oneTimePriceElement.html(`
          <span class="compare-price hidden">${Shopify.formatMoney(variant.compare_at_price)}</span>
          ${Shopify.formatMoney(variant.price)}
          <span class="box_text"> / Serving</span>
        `);
      } else {
        oneTimePriceElement.html(Shopify.formatMoney(variant.price) + '<span class="box_text"> / Serving</span>');
      }
    }
  }
  if (subscribePriceElement) {
    if (activeProduct.find('.serving_text').length > 0) {
      subscribePriceElement.html(`
        <span class="compare-price hidden">${Shopify.formatMoney(variant.price)}</span>
        <span class="regular_price">${Shopify.formatMoney(discount)}<span class="box_text"> / BOX</span></span>
      `);
    } else {
      subscribePriceElement.html(`
        <span class="compare-price hidden">${Shopify.formatMoney(variant.price)}</span>
        <span class="regular_price">${Shopify.formatMoney(discount)}<span class="box_text"> / Serving</span></span>
      `);
    }
  }
  var servingValue = parseInt(serving.serving.split(' ')[0]);
  var oneServingPrice = variant.price / 100 / servingValue;
  var subServingPrice = discount / 100 / servingValue;
  var round_sub_val = `${Math.floor(subServingPrice * 100) / 100}`;
  if (round_sub_val.length == 3) {
    var round_sub_val = round_sub_val + '0';
  }
  oneTimeServingElement.html(`Only $${Math.floor(oneServingPrice * 100) / 100} / <span>Serving</span>`);
  subscribeServingElement.html('Only $' + round_sub_val + ' / <span>Serving</span>');
  if ($('.payment-method_item').length > 0) {
    var withQtyPrice = 0;
    var withQtyComparePrice = 0;
    var withSubQtyPrice = 0;
    var totalQty = 0;
    var addHTML = '';
    $('.pmvt_content .pmvt_content-variants_item').each(function (i, v) {
      if (parseInt($(v).find('.qty-option').val()) > 0) {
        var e_variant = JSON.parse($(v).find('[data-selected-variant]').text());
        var e_sellingPlan = JSON.parse($(v).find('[data-selected-selling]').text())[0];
        var e_current = $('.payment-method_item [name="selling_plan"] option:selected').attr('data-name');
        var e_currentPlan = e_sellingPlan.selling_plans.find(plan => plan.name === e_current);
        var e_discount = parseInt(e_currentPlan.price_adjustments[0].value);
        var qty = parseInt($(v).find('.qty-option').val());
        totalQty += parseInt($(v).find('.qty-option').val());
        withQtyPrice += e_variant.price * qty;
        withQtyComparePrice += e_variant.compare_at_price * qty;
        withSubQtyPrice += e_discount * qty;
        addHTML += `
          <input name="items[${i}]id" value="${e_variant.id}" type="hidden" data-name="${e_variant.name}">
          <input name="items[${i}]quantity" value="${qty}" type="hidden">
          ${$('.payment-methods_wrapper input:checked').val() == 'subscribe' ? `<input name="items[${i}]selling_plan" value="${e_currentPlan.id}" type="hidden">` : ``}
        `;
      }
    });
    if (totalQty >= 25) {
      $('.product_list_qty').addClass('disabled');
    } else {
      $('.product_list_qty').removeClass('disabled');
    }
    if ($('.subscribe_cols').hasClass('active') > 0) {
      if (totalQty > -1 && totalQty <= 15) {
        flavorsText.html('Please Select At Least 15 Pouches');
        selectQty.html(totalQty + '/15');
        selectQty.removeClass('hidden');
      } else if (totalQty > 15 && totalQty <= 24) {
        flavorsText.html('You are currently at ' + totalQty + ' Pouches in your selection!');
        selectQty.html(totalQty + '/25');
        selectQty.addClass('hidden');
      } else if (totalQty == 25) {
        flavorsText.html('Maximum quantity selected');
        selectQty.html(totalQty + '/25');
        selectQty.addClass('hidden');
      }
    } else {
      if (totalQty > -1 && totalQty <= 5) {
        flavorsText.html('Please Select At Least 5 Pouches');
        selectQty.html(totalQty + '/5');
        selectQty.removeClass('hidden');
      } else if (totalQty > 5 && totalQty <= 24) {
        flavorsText.html('You are currently at ' + totalQty + ' Pouches in your selection!');
        selectQty.html(totalQty + '/25');
        selectQty.addClass('hidden');
      } else if (totalQty == 25) {
        flavorsText.html('Maximum quantity selected');
        selectQty.html(totalQty + '/25');
        selectQty.addClass('hidden');
      }
    }
    if (totalQty > 0) {
      totalPriceMain.removeClass('hidden');
    } else {
      totalPriceMain.addClass('hidden');
    }
    $('.step_count').each(function () {
      $(this).removeClass('active_number');
      $(this).removeClass('active');
      if ($(this).attr('data-number') < totalQty) {
        $(this).addClass('active');
      }
      if ($(this).attr('data-number') == totalQty) {
        $(this).addClass('active_number');
      }
    });
    if ($('.payment-methods_wrapper input:checked').val() == 'subscribe') {
      var ttPrice = withSubQtyPrice;
    } else {
      var ttPrice = withQtyPrice;
    }
    if (ttPrice => 0) {
      // if (freeShippingPrice > ttPrice) {
      //   var width = (withQtyPrice * 100) / freeShippingPrice;
      //   var remainPrice = freeShippingPrice - ttPrice;
      //   $('[data-free-get-message]').addClass('hidden');
      //   $('[data-free-remain-message]').removeClass('hidden');
      //   $('[data-free-remain-message]').find('[data-free-price]').html(Shopify.formatMoney(remainPrice));
      //   $('.shipping_bar_line').css('width', width+'%');
      // } else {
      //   var width = 100;
      //   $('[data-free-remain-message]').addClass('hidden');
      //   $('[data-free-get-message]').removeClass('hidden');
      //   $('.shipping_bar_line').css('width', width+'%');
      // }
      if ($('.subscribe_cols').hasClass('active') > 0) {
        $('.step_count_6').removeClass('default_number');
        $('.step_count_6 .step_number_text').addClass('hidden');
        $('.step_count_16').addClass('default_number');
        $('.step_count_16 .step_number_text').removeClass('hidden');
        var width = 100;
        $('[data-free-remain-message]').addClass('hidden');
        $('[data-free-get-message]').removeClass('hidden');
        $('.shipping_bar_line').css('width', width + '%');
      } else {
        $('.step_count_6').addClass('default_number');
        $('.step_count_6 .step_number_text').removeClass('hidden');
        $('.step_count_16').removeClass('default_number');
        $('.step_count_16 .step_number_text').addClass('hidden');
        if (freeShippingPrice > ttPrice) {
          var width = withQtyPrice * 100 / freeShippingPrice;
          var remainPrice = freeShippingPrice - ttPrice;
          $('[data-free-get-message]').addClass('hidden');
          $('[data-free-remain-message]').removeClass('hidden');
          $('[data-free-remain-message]').find('[data-free-price]').html(Shopify.formatMoney(remainPrice));
          $('.shipping_bar_line').css('width', width + '%');
        } else {
          var width = 100;
          $('[data-free-remain-message]').addClass('hidden');
          $('[data-free-get-message]').removeClass('hidden');
          $('.shipping_bar_line').css('width', width + '%');
        }
      }
    }
    if ($('.subscribe_cols').hasClass('active') > 0) {
      if (totalQty == 15 || totalQty > 15) {
        form.find('.add-data').html(addHTML);
        $('.pdp_product_form__submit').removeAttr('disabled');
        $('.select_flavors_cols').addClass('active');
        if ($('.payment-methods_wrapper input:checked').val() == 'subscribe') {
          $('.shipping_saving_text').html(`You are saving ${discount_number}% on your order!`);
        } else {
          $('.shipping_saving_text').html(`Save ${discount_number}% and Get Free Shipping with Subscription Plan`);
        }
      } else {
        form.find('.add-data').html('');
        $('.pdp_product_form__submit').attr('disabled', 'disabled');
        $('.select_flavors_cols').removeClass('active');
        $('.shipping_saving_text').html('');
      }
    } else {
      if (totalQty == 5 || totalQty > 5) {
        form.find('.add-data').html(addHTML);
        $('.pdp_product_form__submit').removeAttr('disabled');
        $('.select_flavors_cols').addClass('active');
        if ($('.payment-methods_wrapper input:checked').val() == 'subscribe') {
          $('.shipping_saving_text').html(`You are saving ${discount_number}% on your order!`);
        } else {
          $('.shipping_saving_text').html(`Save ${discount_number}% and Get Free Shipping with Subscription Plan`);
        }
      } else {
        form.find('.add-data').html('');
        $('.pdp_product_form__submit').attr('disabled', 'disabled');
        $('.select_flavors_cols').removeClass('active');
        $('.shipping_saving_text').html('');
      }
    }
    if ($('.payment-methods_wrapper input:checked').val() == 'subscribe') {
      totalPriceElement.html(Shopify.formatMoney(withSubQtyPrice));
      if (discount < withQtyPrice) {
        totalComparePriceElement.show();
        saveElement.show();
        totalComparePriceElement.html(Shopify.formatMoney(withQtyPrice));
        var save = Math.round((withQtyPrice - withQtyPrice * discount) * 100 / withQtyPrice);
        saveElement.html(`Save ${discount_number}%`);
        subDif.html(`You’re saving <b>${Shopify.formatMoney(withQtyPrice - withSubQtyPrice)}</b>`);
      } else {
        totalComparePriceElement.hide();
        saveElement.hide();
      }
      if (free > 8000) {
        $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
        $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
        $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
      } else {
        if (withSubQtyPrice > 8000) {
          $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
          $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
          $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
        } else {
          $('.pdp_free_shipping_text').removeClass('active').addClass('lock_shipping_bar');
          $('.pdp_free_shipping_text .false_free_shipping').removeClass('hidden');
          $('.pdp_free_shipping_text .true_free_shipping').addClass('hidden');
        }
      }
    } else {
      totalPriceElement.html(Shopify.formatMoney(withQtyPrice));
      if (withQtyPrice < withQtyComparePrice) {
        totalComparePriceElement.show();
        saveElement.show();
        totalComparePriceElement.html(Shopify.formatMoney(withQtyComparePrice));
        var save = Math.round((withQtyComparePrice - withQtyPrice) * 100 / withQtyComparePrice);
        saveElement.html(`Save ${save}%`);
      } else {
        totalComparePriceElement.hide();
        saveElement.hide();
      }
      if (free > 8000) {
        $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
        $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
        $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
      } else {
        if (withQtyPrice > 8000) {
          $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
          $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
          $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
        } else {
          $('.pdp_free_shipping_text').removeClass('active').addClass('lock_shipping_bar');
          $('.pdp_free_shipping_text .false_free_shipping').removeClass('hidden');
          $('.pdp_free_shipping_text .true_free_shipping').addClass('hidden');
        }
      }
    }
  } else {
    totalPriceElement.html(Shopify.formatMoney(withQtyPrice));
    if (withQtyPrice < withQtyComparePrice) {
      totalComparePriceElement.show();
      saveElement.show();
      totalComparePriceElement.html(Shopify.formatMoney(withQtyComparePrice));
      var save = Math.round((withQtyComparePrice - withQtyPrice) * 100 / withQtyComparePrice);
      saveElement.html(`Save ${save}%`);
    } else {
      totalComparePriceElement.hide();
      saveElement.hide();
    }
    if (free > 8000) {
      $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
      $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
      $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
    } else {
      if (withQtyPrice > 8000) {
        $('.pdp_free_shipping_text').removeClass('lock_shipping_bar').addClass('active');
        $('.pdp_free_shipping_text .false_free_shipping').addClass('hidden');
        $('.pdp_free_shipping_text .true_free_shipping').removeClass('hidden');
      } else {
        $('.pdp_free_shipping_text').removeClass('active').addClass('lock_shipping_bar');
        $('.pdp_free_shipping_text .false_free_shipping').removeClass('hidden');
        $('.pdp_free_shipping_text .true_free_shipping').addClass('hidden');
      }
    }
  }
}
$(document).ready(function () {
  $('body').on('click', '.pmvt_content-item.pro_type .pmvt_content-variants_item', function (e) {
    e.preventDefault();
    $('.pmvt_content .pmvt_content-variants_item').removeClass('active');
    $(this).addClass('active');
    if ($(this).hasClass('pmvt_disable')) {
      $('.wait-product-form__submit').removeClass('hidden');
      $('.main-product-form__submit, .product-policy_text').addClass('hidden');
    } else {
      $('.wait-product-form__submit').addClass('hidden');
      $('.main-product-form__submit, .product-policy_text').removeClass('hidden');
    }
    var variant = window.selectedVariant;
    changePrice(variant, true);
  });
  $('body').on('click', '#ProductSubmitButton-sticky', function () {
    document.querySelector('.product-form [type="submit"]').click();
  });
  $('.pmvt_link').click(function (e) {
    e.preventDefault();
    $('.pmvt_link').removeClass('active');
    $(this).addClass('active');
    $('.pmvt_content-item').hide();
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    if ($(this).hasClass('enable_snack_bars')) {
      $('.wait-product-form__submit').removeClass('hidden');
      $('.main-product-form__submit, .product-policy_text').addClass('hidden');
    } else {
      $('.wait-product-form__submit').addClass('hidden');
      $('.main-product-form__submit, .product-policy_text').removeClass('hidden');
    }
    return false;
  });

  // FAQ
  $('.faq-tab_link').click(function (e) {
    e.preventDefault();
    $('.faq-search_form-input').val('');
    $('.faq-content_button').text("Load More");
    $('.faq-tab_link').removeClass('active');
    $('.faq-tab_content-wrap').removeClass('active');
    $(this).addClass('active');
    $('.faq-tab_content-wrap').hide();
    var activeTab = $(this).attr('href');
    $(activeTab).addClass('active');
    $(activeTab).fadeIn();
    return false;
  });
  $('.faq-item_header').click(function (e) {
    e.preventDefault();
    $('.faq-item_content').slideUp('100');
    $('.faq-item_header').removeClass('active');
    $('.faq-item').removeClass('active');
    if (!$(this).parent().find('.faq-item_content').is(":visible")) {
      $(this).parent().find('.faq-item_content').slideToggle('500');
      $(this).toggleClass('active');
      $(this).parent().toggleClass('active');
    }
  });

  //FAQ Mobile Accordian
  $('.faq-tab_accordian-header').click(function () {
    $(this).toggleClass('active');
    $(this).next('.faq-tab_content-main').slideToggle();
  });

  // $('body').on('change', '[name="selling_plan"]', function() {
  //   var variant = window.selectedVariant;
  //   changePrice(variant);
  // });

  $('.custom-select').each(function () {
    var $this = $(this),
      numberOfOptions = $(this).children('option').length;
    $this.addClass('select-hidden');
    $this.wrap('<div class="custom-select relative"></div>');
    $this.after('<div class="select-styled"></div>');
    var $styledSelect = $this.next('div.select-styled');
    if ($this.children('option:selected')) {
      $styledSelect.text($this.children('option:selected').text());
    } else {
      $styledSelect.text($this.children('option').eq(0).text());
    }
    var $list = $('<ul />', {
      'class': 'select-options'
    }).insertAfter($styledSelect);
    for (var i = 0; i < numberOfOptions; i++) {
      $('<li />', {
        text: $this.children('option').eq(i).text(),
        rel: $this.children('option').eq(i).val()
      }).appendTo($list);
      if ($this.children('option').eq(i).is(':selected')) {
        $list.find('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected');
      }
    }
    var $listItems = $list.children('li');
    $styledSelect.click(function (e) {
      e.stopPropagation();
      $('div.select-styled.active').not(this).each(function () {
        $(this).removeClass('active').next('ul.select-options').hide();
      });
      $(this).toggleClass('active').next('ul.select-options').toggle();
      if ($(this).parents('.custom-select').find('.qty-option').length) {
        $('.pmvt_content .pmvt_content-variants_item').removeClass('active');
        $(this).parents('.pmvt_content-variants_item').addClass('active');
        if ($(this).parents('.pmvt_content-variants_item').hasClass('pmvt_disable')) {
          $('.wait-product-form__submit').removeClass('hidden');
          $('.main-product-form__submit, .product-policy_text').addClass('hidden');
        } else {
          $('.wait-product-form__submit').addClass('hidden');
          $('.main-product-form__submit, .product-policy_text').removeClass('hidden');
        }
        var variant = window.selectedVariant;
        changePrice(variant, true);
      }
    });
    $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $this.val($(this).attr('rel'));
      $this[0].dispatchEvent(new Event('change', {
        bubbles: true
      }));
      if ($this.hasClass('selling-option') || $this.hasClass('qty-option')) {
        var variant = window.selectedVariant;
        changePrice(variant, false);
      }
      $list.find('li.is-selected').removeClass('is-selected');
      $list.find('li[rel="' + $(this).attr('rel') + '"]').addClass('is-selected');
      $list.hide();
    });
    $(document).click(function () {
      $styledSelect.removeClass('active');
      $list.hide();
    });
  });
  $('body').on('click', '.payment-method_item', function () {
    $('.payment-method_item').removeClass('active');
    $(this).addClass('active');
    $('.payment-methods_wrapper input').prop('checked', false);
    $(this).find('input').prop('checked', true);
    if ($('.payment-methods_wrapper input:checked').val() == 'subscribe') {
      $('[name="selling_plan"]').removeAttr('disabled');
      $('.product-st_text .total_sub_label').removeClass('hidden');
      $('.product-st_text .total_one_label').addClass('hidden');
    } else {
      $('[name="selling_plan"]').attr('disabled', 'disabled');
      $('.product-st_text .total_sub_label').addClass('hidden');
      $('.product-st_text .total_one_label').removeClass('hidden');
    }
    var variant = window.selectedVariant;
    changePrice(variant, false);
  });
  $('.faq-content_button').click(function (e) {
    e.preventDefault();
    var value = $('.faq-search_form-input').val();
    if (value != '') {
      var count = 0;
      $(".faq-tab_content-wrap.active .faq-item").filter(function (i, v) {
        if ($(this).text().toLowerCase().indexOf(value) > -1) {
          count++;
          if (count > 5) {
            $(this).toggle();
          }
        }
      });
    } else {
      $(this).parents('.faq-tab_content-main').find('.faq-item').each(function (i, v) {
        if (i > 5) {
          $(this).toggle();
        }
      });
    }
    if ($(this).text() == "Load More") {
      $(this).text("View Less");
    } else {
      $(this).text("Load More");
    }
  });
  var width = $(window).width();
  if (width < 990) {
    $('.sf-menu_title').click(function () {
      $(this).toggleClass('active');
      $(this).next('.sf-menu').slideToggle();
    });
  }
  $('.submobile-menu_link').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('.mobile-submenu-ul').slideToggle();
  });
  $('.min-menu-toggle,.mobile-menu_overlay').click(function () {
    $('.mobile-menu').toggleClass('active');
    $('.mobile-menu_overlay').toggle();
  });
  $('.mobile-menu_close').click(function () {
    $('.mobile-menu').toggleClass('active');
    $('.mobile-menu_overlay').toggle();
  });
  $('.feel-diference .fd-tabs_item').click(function (e) {
    e.preventDefault();
    $('.feel-diference .fd-tabs_item').removeClass('active');
    $(this).addClass('active');
    $('.fd-tabs_content-main').hide();
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    window.scroll({
      top: $('.feel-diference .fd_wrap').first().offset().top - $('.feel-diference .fd-tab').outerHeight() - $('.site-header').outerHeight() - 50,
      left: 0,
      behavior: 'smooth'
    });
    return false;
  });
  $('.ingredients-tab .fd-tabs_item').click(function (e) {
    e.preventDefault();
    $('.ingredients-tab .fd-tabs_item').removeClass('active');
    $(this).addClass('active');
    $('.ingredients-tab-content').hide();
    var activeTab = $(this).attr('data-tab-href');
    $('.ingredients-tab-content.' + activeTab).fadeIn();
    window.scroll({
      top: $('[data-section="whats-under"]:visible').first().offset().top - $('[data-section="ingredients-tab"]').outerHeight() - $('.site-header').outerHeight() - 50,
      left: 0,
      behavior: 'smooth'
    });
    return false;
  });
  $('.fd-tabs_content-tabs_link').click(function (e) {
    e.preventDefault();
    $(this).parents('.fd-tabs_content-main').find('.fd-tabs_content-tabs_link').removeClass('active');
    $(this).parents('.fd-tabs_content').find('.fdtci-block_header').removeClass('active');
    $(this).addClass('active');
    $(this).parents('.fd-tabs_content-main').find('.fdtci-block').hide();
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });
  $('.fdtci-block_header').click(function (e) {
    e.preventDefault();
    $(this).parents('.fd-tabs_content-main').find('.fdtci-block_content').slideUp('100');
    $(this).parents('.fd-tabs_content-main').find('.fdtci-block_header').removeClass('active');
    if (!$(this).parent().find('.fdtci-block_content').is(":visible")) {
      $(this).parent().find('.fdtci-block_content').slideToggle('500');
      $(this).toggleClass('active');
      $(this).parent().toggleClass('active');
      var _this = this;
      setTimeout(function () {
        window.scroll({
          top: $(_this).parent().offset().top - $('.site-header').outerHeight() - $('.feel-diference .fd-tab').outerHeight() - 10,
          left: 0,
          behavior: 'smooth'
        });
      }, 500);
    }
  });
  $("body").on("keyup click", '.faq-search_form-input', function () {
    var value = $(this).val().toLowerCase();
    $('.no-result').remove();
    var count = 0;
    $(".faq-tab_content-wrap.active .faq-item").filter(function (i, v) {
      if ($(this).text().toLowerCase().indexOf(value) > -1) {
        count++;
        if (count < 7) {
          $(this).show();
        } else {
          $(this).hide();
        }
      } else {
        $(this).hide();
      }
    });
    if ($(this).val() != '') {
      if ($(".faq-tab_content-wrap.active .faq-item:visible").length == 0) {
        var html = `<div class="no-result">							
          <p class="products-faq__empty-search-no-results-heading">
            Sorry, we couldn’t find any matches for <b>${$(this).val()}</b>
          </p>
          <p class="products-faq__empty-search-no-results-text">
            Please try searching with another term
          </p>
        </div>`;
        if ($(window).width() < 750) {
          $('.faq-content').prepend(html);
        } else {
          $('.faq-content').append(html);
        }
      }
      if ($(".faq-tab_content-wrap.active .faq-item").length > 6) {
        if ($(".faq-tab_content-wrap.active .faq-item:visible").length <= 6) {
          $('.faq-tab_content-wrap.active .faq-content_button-wrapper').hide();
        } else {
          $('.faq-tab_content-wrap.active .faq-content_button-wrapper').show();
        }
      }
    } else {
      if ($(".faq-tab_content-wrap.active .faq-item").length > 6) {
        $('.faq-tab_content-wrap.active .faq-content_button-wrapper').show();
      }
      $;
    }
  });
  $('body').on('click', '.product-nutrition-label', function (e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    var mainTabId = $('[data-section="feel-difference"]').find('[data-id="' + id + '"]').parents('.fd-tabs_content-main').attr('id');
    $('[data-section="feel-difference"]').find('.fd-tabs_item[href="#' + mainTabId + '"]').trigger('click');
    if ($(window).width() < 750) {
      $('[data-section="feel-difference"]').find('.fdtci-block_header[data-id="' + id + '"]').trigger('click');
    } else {
      $('[data-section="feel-difference"]').find('.fd-tabs_content-tabs_link[data-id="' + id + '"]').trigger('click');
    }
    window.scroll({
      top: $('[data-section="feel-difference"]').offset().top - $('.site-header').outerHeight(),
      left: 0,
      behavior: 'smooth'
    });
  });
  $(window).scroll(function () {
    if ($('.hero').length) {
      var Product_up = $('.hero').offset().top;
      var product_section_height = $('.hero').outerHeight();
      var full_scroll = Product_up + product_section_height - $('.header-wrapper').outerHeight();
      if ($(this).scrollTop() > full_scroll) {
        if ($(this).scrollTop() < $('.site-footer').offset().top - $('.header-wrapper').outerHeight() - $('.sticky-button').outerHeight() - 300) {
          $('body .sticky-button').addClass('active');
        } else {
          $('body .sticky-button').removeClass('active');
        }
      } else {
        $('body .sticky-button').removeClass('active');
      }
    }
    if ($('.main-product_wrap').length) {
      var Product_up = $('.main-product_wrap').offset().top;
      var product_section_height = $('.main-product_wrap').outerHeight();
      var full_scroll = Product_up + product_section_height - $('.header-wrapper').outerHeight();
      if ($(this).scrollTop() > full_scroll) {
        if ($(this).scrollTop() < $('.site-footer').offset().top - $('.header-wrapper').outerHeight() - $('.pdp-sticky-bottom').outerHeight() - 300) {
          $('body .pdp-sticky-bottom').addClass('active');
        } else {
          $('body .pdp-sticky-bottom').removeClass('active');
        }
      } else {
        $('body .pdp-sticky-bottom').removeClass('active');
      }
    }
    if ($('[data-section="whats-under"]').length) {
      var secH = $('[data-section="whats-under"]:visible').last().offset().top + $('[data-section="whats-under"]:visible').last().outerHeight() - $('.site-header').outerHeight() - $('[data-section="ingredients-tab"]').outerHeight();
      if (secH < $(window).scrollTop()) {
        $('.ingredients-tab').parent().removeClass('sticky-ingredients-tab');
      } else {
        $('.ingredients-tab').parent().addClass('sticky-ingredients-tab');
      }
    }
  });
  if ($('[data-section="whats-under"]').length) {
    var secH = $('[data-section="whats-under"]:visible').last().offset().top + $('[data-section="whats-under"]:visible').last().outerHeight() - $('.site-header').outerHeight() - $('[data-section="ingredients-tab"]').outerHeight();
    if (secH < $(window).scrollTop()) {
      $('.ingredients-tab').parent().removeClass('sticky-ingredients-tab');
    } else {
      $('.ingredients-tab').parent().addClass('sticky-ingredients-tab');
    }
  }
  $('body').on('click', '.cart-recommandation_tab-item', function (e) {
    e.preventDefault();
    $('.cart-recommandation_tab-item').removeClass('active');
    $(this).addClass('active');
    $('.cart-recommandation_tab-block').hide();
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });
  $('body').on('click', '.cart-subscription-days_count', function (e) {
    $('.cart_selling-plan-popup').fadeIn();
  });
  $('body').on('click', '.cart-selling-plan-popup__modal_close,.cart_selling-plan-popup_overlay', function (e) {
    $('.cart_selling-plan-popup').fadeOut();
  });
  $('body').on('click', 'a.inner_link', function (e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({
      scrollTop: $(aid).offset().top - 100
    }, 'slow');
  });
  $('body').on('click', '.main-product_wrap .product-meta-review', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $('#looxReviews').offset().top - 80
    }, 'slow');
  });
  if (window.location.href.indexOf('?col=') > 0) {
    function getUrlVars() {
      var vars = [],
        hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }
    var first = getUrlVars()["col"];
    var mydata = first.split("%20");
    var myparavalue = mydata.join(" ");
    myparavalue = myparavalue.replace(/_/g, '&');
    setTimeout(function () {
      window.scroll({
        top: $('#' + myparavalue).offset().top - 100,
        left: 0,
        behavior: 'smooth'
      });
    }, 1500);
  }
  $('body').on('click', 'a.whats_under_tab_btn', function (e) {
    e.preventDefault();
    $(this).closest('.whats_under_tab_content').toggleClass('active');
    $(this).closest('.whats_under_tab_content').find('.whats_under_content').slideToggle();
    var _this = this;
    window.scroll({
      top: $(_this).parent().offset().top - $('.site-header').outerHeight() - $('[data-section="ingredients-tab"]').outerHeight() - 10,
      left: 0,
      behavior: 'smooth'
    });
  });
  function closePopup() {
    $('.popupOverlay').fadeOut('slow');
    $('body').removeClass('popupOpen');
  }
  function openPopup(a) {
    $('.popupOverlay.' + a).fadeIn('slow');
    $('body').addClass('popupOpen');
  }
  $('body').on('click', '.popupinfo', function (e) {
    e.preventDefault();
    var id = $(this).attr('data-popup');
    openPopup(id);
  });
  $('body').on('click', '.cls_popup', function (e) {
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      closePopup();
    }
  });
  window.onclick = function (e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }
  };
  KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    success_message: "Thanks for signing up!"
  });
  $('body').on('click', '.klaviyo__notify_btn', function () {
    var email = $(this).closest('.notify__pdp_form').find('#email').val();
    var id = $(this).closest('.notify__pdp_form').find('.get-pdp-id :selected').val();
    var subscribe_box = $(this).closest('.notify__pdp_form').find('#subscribe_box');
    function isEmail(email) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }
    if (isEmail(email)) {
      $(this).closest('.notify__pdp_form').find('.error_message').hide();
      $(this).closest('.notify__pdp_form').find('.completed_message').show();
      var _this = $(this);
      $.ajax({
        type: "POST",
        url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data: {
          a: "XxKAAV",
          email: email,
          variant: id,
          platform: "shopify"
        },
        success: function (response) {
          console.log("AJAX Success:", response);
          _this.closest('.notify__pdp_form').find('.completed_message').show();
          _this.closest('.notify__pdp_form').find('#email').val('');
          _this.closest('.notify__pdp_form').find('#subscribe_box').prop("checked", false);
          if ($(subscribe_box).is(':checked')) {
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
              "method": "POST",
              "headers": {
                "content-type": "application/x-www-form-urlencoded",
                "cache-control": "no-cache"
              },
              "data": {
                "g": "TCnNcp",
                "email": email
              }
            };
            $.ajax(settings).done(function (response) {}).fail(function (response) {});
          }
        },
        error: function (e) {
          console.log("AJAX Error:", e);
        }
      });
    } else {
      console.log("Invalid email entered:", email);
      $(this).closest('.notify__pdp_form').find('.error_message').show();
      $(this).closest('.notify__pdp_form').find('.completed_message').hide();
    }
  });
  Fancybox.bind('[data-fancybox]', {
    // Custom options
  });
  $('body').on('click', '.product_list_qty .adjust', function () {
    var ip = parseInt($(this).closest('.product_list_qty').find('input').val());
    if ($(this).hasClass('plus')) {
      if (!$(this).closest('.product_list_qty').hasClass('disabled')) {
        ip = ip + 1;
      }
    } else {
      ip = ip - 1;
    }
    if (ip < 0) {
      return false;
    }
    $(this).closest('.product_list_qty').find('input').val(ip);
    var Nip = parseInt($(this).closest('.product_list_qty').find('input').val());
    if (Nip == 0) {
      $(this).closest('.product_list_qty').find('.qty_box').addClass('hidden');
      $(this).closest('.product_list_qty').find('.add_to_box_btn').removeClass('hidden');
    } else {
      $(this).closest('.product_list_qty').find('.qty_box').removeClass('hidden');
      $(this).closest('.product_list_qty').find('.add_to_box_btn').addClass('hidden');
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".gr-mobile-menu__toggle");
  toggleButtons.forEach(button => {
    button.addEventListener("click", function () {
      const mobileMenu = document.querySelector(".gr-mobile-menu");
      const body = document.body;
      if (mobileMenu) {
        mobileMenu.classList.toggle("gr-mobile-menu--open");
      }
      body.classList.toggle("gr-mobile-menu-is-open");
    });
  });
  const buttons = document.querySelectorAll(".gr-mobile-menu__back-btn, .gr-mobile-menu__link--with-submenu");
  buttons.forEach(button => {
    button.addEventListener("click", function (event) {
      if (button.tagName === "A") {
        event.preventDefault();
      }
      const parentItem = button.closest(".gr-mobile-menu__item");
      if (parentItem) {
        parentItem.classList.toggle("gr-active");
      }
    });
  });
  const menuItems = document.querySelectorAll(".gr-has-menu");
  function calculateAndSetPadding(menuItem) {
    const parentItem = menuItem.closest(".gr-header__desktop-menu-item");
    if (parentItem) {
      const distanceFromLeft = parentItem.getBoundingClientRect().left;
      const roundedDistance = distanceFromLeft.toFixed(1);
      parentItem.style.setProperty("--padding-start", `${roundedDistance}px`);
    }
  }
  menuItems.forEach(menuItem => {
    menuItem.addEventListener("click", function (event) {
      if (menuItem.tagName === "A") {
        event.preventDefault();
      }
      if (menuItem.classList.contains("gr-menu-active")) {
        menuItem.classList.remove("gr-menu-active");
      } else {
        menuItems.forEach(item => item.classList.remove("gr-menu-active"));
        menuItem.classList.add("gr-menu-active");
        if (menuItem.classList.contains("gr-has-menu--mega")) {
          calculateAndSetPadding(menuItem);
          let sibling = menuItem.nextElementSibling;
          while (sibling) {
            if (sibling.classList.contains("gr-header-menu__desktop-megamenu")) {
              const targetElement = sibling.querySelector('[data-grjs="with-submenu"]');
              if (targetElement) {
                targetElement.classList.add("gr-submenu-active");
              }
              break;
            }
            sibling = sibling.nextElementSibling;
          }
        }
      }
    });
  });
  document.addEventListener("click", function (event) {
    menuItems.forEach(menuItem => {
      const parentItem = menuItem.closest(".gr-header__desktop-menu-item");
      const submenu = parentItem?.querySelector(".gr-header__desktop-submenu");
      if (menuItem.classList.contains("gr-menu-active") && submenu && !submenu.contains(event.target) && !menuItem.contains(event.target)) {
        menuItem.classList.remove("gr-menu-active");
      }
    });
  });
  window.addEventListener("resize", function () {
    menuItems.forEach(menuItem => {
      if (menuItem.classList.contains("gr-has-menu--mega") && menuItem.classList.contains("gr-menu-active")) {
        calculateAndSetPadding(menuItem);
      }
    });
  });
});